const STORAGE_KEY = 'smardie_referral_code'

function normalizeCode (raw) {
  return String(raw || '')
    .trim()
    .toUpperCase()
    .replace(/[^A-Z0-9]/g, '')
    .slice(0, 32)
}

export function captureReferralFromQuery (query) {
  if (!query || typeof query !== 'object') return
  const raw = query.ref || query.referral || query.referral_code || ''
  const code = normalizeCode(raw)
  if (!code) return
  try {
    localStorage.setItem(STORAGE_KEY, code)
  } catch (e) {
    /* ignore */
  }
}

export function getStoredReferralCode () {
  try {
    return normalizeCode(localStorage.getItem(STORAGE_KEY) || '')
  } catch (e) {
    return ''
  }
}

export function setStoredReferralCode (code) {
  const normalized = normalizeCode(code)
  try {
    if (normalized) localStorage.setItem(STORAGE_KEY, normalized)
    else localStorage.removeItem(STORAGE_KEY)
  } catch (e) {
    /* ignore */
  }
  return normalized
}

export function clearStoredReferralCode () {
  try {
    localStorage.removeItem(STORAGE_KEY)
  } catch (e) {
    /* ignore */
  }
}

export default {
  captureReferralFromQuery,
  getStoredReferralCode,
  setStoredReferralCode,
  clearStoredReferralCode
}
